import { useCallback, useMemo } from 'react';

import { DEFAULT_ENVIRONMENT_ID } from 'src/constants/storage';
import { WDAC_SCRIPT_EXECUTION_QUERY_KEY } from 'src/constants/query';
import { EXPANDED_ROWS_LIMIT } from 'src/constants/table';
import useSubscribeStorage from 'src/hooks/useSubscribeStorage';
import useInfiniteFetch from 'src/queries/useInfiniteFetch';
import useQueryParams from 'src/hooks/useQueryParams';
import { parseQueryToApiQuery } from 'src/utils/query.utils';
import ScriptExecutionService from '../../../../services/script-execution.service';

const useFetchWDACScriptExecution = () => {
  const customerEnvId = useSubscribeStorage(DEFAULT_ENVIRONMENT_ID);

  const {
    queryObject: { searchValue: initialSearchValue, filters = {} },
  } = useQueryParams();

  const query = useMemo(
    () =>
      parseQueryToApiQuery({
        filters,
        searchValue: initialSearchValue,
      }),
    [filters, initialSearchValue],
  );

  const fetchFunction = useCallback(
    ({ page, limit }) =>
      ScriptExecutionService.getScriptExecutionAll({
        limit,
        page,
        customerEnvId,
        query,
      }),
    [customerEnvId, query],
  );

  const response = useInfiniteFetch({
    queryKey: [WDAC_SCRIPT_EXECUTION_QUERY_KEY, query, customerEnvId],
    fetchFunction,
    expandedRowsLimit: EXPANDED_ROWS_LIMIT,
    itemName: 'scriptExecutions',
  });

  return {
    ...response,
    query,
  };
};

export default useFetchWDACScriptExecution;
